import React from 'react'
import styled, { css } from 'styled-components'
import { theme } from 'styled-tools'

const TextWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 12px 10px;
  margin: 0px auto;
  height: 100%;
  background-color: ${theme('textOption.backgroundColor')};
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.15);
  border: 2px solid #ffffff;
  border-radius: 5px;
  min-width: 120px;
  margin-right: 7px;

  ${(props) => props.theme.media.min.sm`
    min-width: 137px;
  `}
  ${(props) =>
    props.$active &&
    css`
      border: 2px solid #192228;
    `}
`
const Text = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${theme('textOption.text.minHeight')};
  margin: 0px auto;
  font-family: ${theme('textOption.text.fontFamily')};
  font-size: ${theme('textOption.text.fontSize.mobile')};
  font-weight: ${theme('textOption.text.fontWeight')};
  color: ${theme('colors.link')};
  white-space: pre-wrap;
  text-align: ${theme('textOption.text.textAlign')};
  font-style: ${theme('textOption.text.fontStyle')};

  em {
    font-weight: 400;
  }

  ${(props) => props.theme.media.min.sm`
    font-size: ${theme('textOption.text.fontSize.desktop')};
  `}
`

const TextBoxedOption = ({ text, active }) => (
  <TextWrap $active={active}>
    {text && <Text dangerouslySetInnerHTML={{ __html: text }} />}
  </TextWrap>
)

export default TextBoxedOption
